export const filterOnActualDate = (data, actualDate) => {
  const result = data.map(dataItem => {
    return {
      domainName: dataItem?.domainName,
      data: dataItem?.data?.filter(item => item.date === actualDate),
    }
  })
  return result
}
